import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from "./HomePage";
import Layout from "./Layout";
import PrivacyPage from "./PrivacyPage";
import { Analytics } from "@vercel/analytics/react"

function App() {
    return (
    <div className="App">
        <Router>
            <Routes>
                <Route path="/" element={<Layout />} >
                    <Route index element={<HomePage />} />
                    {/*<Route path="/services" element={<ServicesPage />} />*/}
                    <Route path="/privacy" element={<PrivacyPage />} />
                </Route>
            </Routes>
        </Router>
        <Analytics/>
    </div>
    );
}

export default App;
